//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.2.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ReportsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    listReports(organizationId: number): Promise<ReportListItem[]> {
        let url_ = this.baseUrl + "/reporting/api/reports/list/organization/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListReports(_response);
        });
    }

    protected processListReports(response: Response): Promise<ReportListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportListItem[]>(null as any);
    }

    getReport(reportId: number): Promise<ReportItem> {
        let url_ = this.baseUrl + "/reporting/api/reports/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReport(_response);
        });
    }

    protected processGetReport(response: Response): Promise<ReportItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportItem>(null as any);
    }

    getUserReport(userReportId: number): Promise<UserReportItem> {
        let url_ = this.baseUrl + "/reporting/api/reports/userReport/{userReportId}";
        if (userReportId === undefined || userReportId === null)
            throw new Error("The parameter 'userReportId' must be defined.");
        url_ = url_.replace("{userReportId}", encodeURIComponent("" + userReportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserReport(_response);
        });
    }

    protected processGetUserReport(response: Response): Promise<UserReportItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserReportItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserReportItem>(null as any);
    }

    createUserReport(model: UserReportCreateItem): Promise<UserReportItem> {
        let url_ = this.baseUrl + "/reporting/api/reports/userReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUserReport(_response);
        });
    }

    protected processCreateUserReport(response: Response): Promise<UserReportItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserReportItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserReportItem>(null as any);
    }

    updateUserReport(model: UserReportUpdateItem): Promise<UserReportItem> {
        let url_ = this.baseUrl + "/reporting/api/reports/userReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserReport(_response);
        });
    }

    protected processUpdateUserReport(response: Response): Promise<UserReportItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserReportItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserReportItem>(null as any);
    }

    deleteUserReport(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/reporting/api/reports/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUserReport(_response);
        });
    }

    protected processDeleteUserReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getReportSelectionLists(reportId: number): Promise<ReportSelectionsListItem> {
        let url_ = this.baseUrl + "/reporting/api/reports/{reportId}/list/selection";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReportSelectionLists(_response);
        });
    }

    protected processGetReportSelectionLists(response: Response): Promise<ReportSelectionsListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportSelectionsListItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportSelectionsListItem>(null as any);
    }

    getReportData(reportId: number, filterSelections: ReportFilterSelection[]): Promise<ReportDataItem> {
        let url_ = this.baseUrl + "/reporting/api/reports/{reportId}/data";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterSelections);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReportData(_response);
        });
    }

    protected processGetReportData(response: Response): Promise<ReportDataItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportDataItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportDataItem>(null as any);
    }

    userReportHasUserReportAvailabilities(userReportId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/reporting/api/reports/{userReportId}/hasUserReportAvailability";
        if (userReportId === undefined || userReportId === null)
            throw new Error("The parameter 'userReportId' must be defined.");
        url_ = url_.replace("{userReportId}", encodeURIComponent("" + userReportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserReportHasUserReportAvailabilities(_response);
        });
    }

    protected processUserReportHasUserReportAvailabilities(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class VersionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAppVersion(): Promise<string> {
        let url_ = this.baseUrl + "/reporting/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppVersion(_response);
        });
    }

    protected processGetAppVersion(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ReportListItem implements IReportListItem {
    reportId!: number;
    userReportId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isBaseReport!: boolean;
    isUserReport!: boolean;
    isAreaReport!: boolean;
    isOrganizationReport!: boolean;
    showReportFields!: boolean;

    constructor(data?: IReportListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.userReportId = _data["userReportId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isBaseReport = _data["isBaseReport"];
            this.isUserReport = _data["isUserReport"];
            this.isAreaReport = _data["isAreaReport"];
            this.isOrganizationReport = _data["isOrganizationReport"];
            this.showReportFields = _data["showReportFields"];
        }
    }

    static fromJS(data: any): ReportListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ReportListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["userReportId"] = this.userReportId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isBaseReport"] = this.isBaseReport;
        data["isUserReport"] = this.isUserReport;
        data["isAreaReport"] = this.isAreaReport;
        data["isOrganizationReport"] = this.isOrganizationReport;
        data["showReportFields"] = this.showReportFields;
        return data;
    }
}

export interface IReportListItem {
    reportId: number;
    userReportId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isBaseReport: boolean;
    isUserReport: boolean;
    isAreaReport: boolean;
    isOrganizationReport: boolean;
    showReportFields: boolean;
}

export class ReportItem implements IReportItem {
    id!: number;
    reportName?: string | undefined;
    reportDescription?: string | undefined;
    useDelegations!: boolean;
    useDrugLists!: boolean;
    useWorkSchedule!: boolean;
    requiredRoleId!: RoleEnum;
    reportSelections!: ReportSelectionItem[];
    reportFields!: ReportFieldItem[];

    constructor(data?: IReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reportSelections = [];
            this.reportFields = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportName = _data["reportName"];
            this.reportDescription = _data["reportDescription"];
            this.useDelegations = _data["useDelegations"];
            this.useDrugLists = _data["useDrugLists"];
            this.useWorkSchedule = _data["useWorkSchedule"];
            this.requiredRoleId = _data["requiredRoleId"];
            if (Array.isArray(_data["reportSelections"])) {
                this.reportSelections = [] as any;
                for (let item of _data["reportSelections"])
                    this.reportSelections!.push(ReportSelectionItem.fromJS(item));
            }
            if (Array.isArray(_data["reportFields"])) {
                this.reportFields = [] as any;
                for (let item of _data["reportFields"])
                    this.reportFields!.push(ReportFieldItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new ReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportName"] = this.reportName;
        data["reportDescription"] = this.reportDescription;
        data["useDelegations"] = this.useDelegations;
        data["useDrugLists"] = this.useDrugLists;
        data["useWorkSchedule"] = this.useWorkSchedule;
        data["requiredRoleId"] = this.requiredRoleId;
        if (Array.isArray(this.reportSelections)) {
            data["reportSelections"] = [];
            for (let item of this.reportSelections)
                data["reportSelections"].push(item.toJSON());
        }
        if (Array.isArray(this.reportFields)) {
            data["reportFields"] = [];
            for (let item of this.reportFields)
                data["reportFields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportItem {
    id: number;
    reportName?: string | undefined;
    reportDescription?: string | undefined;
    useDelegations: boolean;
    useDrugLists: boolean;
    useWorkSchedule: boolean;
    requiredRoleId: RoleEnum;
    reportSelections: ReportSelectionItem[];
    reportFields: ReportFieldItem[];
}

export enum RoleEnum {
    Admin = "Admin",
    Planner = "Planner",
    Caretaker = "Caretaker",
}

export class ReportSelectionItem implements IReportSelectionItem {
    id!: number;
    selectionId!: SelectionEnum;
    selection!: Selection;
    interval!: boolean;
    multiple!: boolean;
    required!: boolean;
    useDelegations!: boolean;
    useDrugLists!: boolean;
    useWorkSchedule!: boolean;

    constructor(data?: IReportSelectionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selection = new Selection();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.selectionId = _data["selectionId"];
            this.selection = _data["selection"] ? Selection.fromJS(_data["selection"]) : new Selection();
            this.interval = _data["interval"];
            this.multiple = _data["multiple"];
            this.required = _data["required"];
            this.useDelegations = _data["useDelegations"];
            this.useDrugLists = _data["useDrugLists"];
            this.useWorkSchedule = _data["useWorkSchedule"];
        }
    }

    static fromJS(data: any): ReportSelectionItem {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSelectionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["selectionId"] = this.selectionId;
        data["selection"] = this.selection ? this.selection.toJSON() : <any>undefined;
        data["interval"] = this.interval;
        data["multiple"] = this.multiple;
        data["required"] = this.required;
        data["useDelegations"] = this.useDelegations;
        data["useDrugLists"] = this.useDrugLists;
        data["useWorkSchedule"] = this.useWorkSchedule;
        return data;
    }
}

export interface IReportSelectionItem {
    id: number;
    selectionId: SelectionEnum;
    selection: Selection;
    interval: boolean;
    multiple: boolean;
    required: boolean;
    useDelegations: boolean;
    useDrugLists: boolean;
    useWorkSchedule: boolean;
}

export enum SelectionEnum {
    Area = "Area",
    Customer = "Customer",
    TemplateActivity = "TemplateActivity",
    SignType = "SignType",
    TemplateActivityCategory = "TemplateActivityCategory",
    Legislation = "Legislation",
    Participant = "Participant",
    DeclinedParticipant = "DeclinedParticipant",
    Delegation = "Delegation",
    DelegationCategory = "DelegationCategory",
    UnitType = "UnitType",
    Recurrence = "Recurrence",
    TemplateActivityType = "TemplateActivityType",
    SignDate = "SignDate",
    PlannedDate = "PlannedDate",
    DelegationEndDate = "DelegationEndDate",
    DistributionGroupType = "DistributionGroupType",
    DistributionAggregateType = "DistributionAggregateType",
    User = "User",
    Route = "Route",
    TemporaryActivity = "TemporaryActivity",
    SignedBy = "SignedBy",
}

export class Selection implements ISelection {
    id!: SelectionEnum;
    value!: string;
    isList!: boolean;
    isSwitch!: boolean;
    isOption!: boolean;
    isDate!: boolean;

    constructor(data?: ISelection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.isList = _data["isList"];
            this.isSwitch = _data["isSwitch"];
            this.isOption = _data["isOption"];
            this.isDate = _data["isDate"];
        }
    }

    static fromJS(data: any): Selection {
        data = typeof data === 'object' ? data : {};
        let result = new Selection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["isList"] = this.isList;
        data["isSwitch"] = this.isSwitch;
        data["isOption"] = this.isOption;
        data["isDate"] = this.isDate;
        return data;
    }
}

export interface ISelection {
    id: SelectionEnum;
    value: string;
    isList: boolean;
    isSwitch: boolean;
    isOption: boolean;
    isDate: boolean;
}

export class ReportFieldItem implements IReportFieldItem {
    id!: number;
    fieldIndex!: number;
    fieldName?: string | undefined;
    headerName?: string | undefined;
    useDelegations!: boolean;
    useDrugLists!: boolean;
    useWorkSchedule!: boolean;
    isMeta!: boolean;
    isLink!: boolean;
    linkTypeId?: LinkTypeEnum | undefined;

    constructor(data?: IReportFieldItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fieldIndex = _data["fieldIndex"];
            this.fieldName = _data["fieldName"];
            this.headerName = _data["headerName"];
            this.useDelegations = _data["useDelegations"];
            this.useDrugLists = _data["useDrugLists"];
            this.useWorkSchedule = _data["useWorkSchedule"];
            this.isMeta = _data["isMeta"];
            this.isLink = _data["isLink"];
            this.linkTypeId = _data["linkTypeId"];
        }
    }

    static fromJS(data: any): ReportFieldItem {
        data = typeof data === 'object' ? data : {};
        let result = new ReportFieldItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fieldIndex"] = this.fieldIndex;
        data["fieldName"] = this.fieldName;
        data["headerName"] = this.headerName;
        data["useDelegations"] = this.useDelegations;
        data["useDrugLists"] = this.useDrugLists;
        data["useWorkSchedule"] = this.useWorkSchedule;
        data["isMeta"] = this.isMeta;
        data["isLink"] = this.isLink;
        data["linkTypeId"] = this.linkTypeId;
        return data;
    }
}

export interface IReportFieldItem {
    id: number;
    fieldIndex: number;
    fieldName?: string | undefined;
    headerName?: string | undefined;
    useDelegations: boolean;
    useDrugLists: boolean;
    useWorkSchedule: boolean;
    isMeta: boolean;
    isLink: boolean;
    linkTypeId?: LinkTypeEnum | undefined;
}

export enum LinkTypeEnum {
    Planning = "Planning",
    User = "User",
    UserDelegation = "UserDelegation",
    Customer = "Customer",
    SigningModal = "SigningModal",
}

export class UserReportItem implements IUserReportItem {
    id!: number;
    reportName?: string | undefined;
    reportDescription?: string | undefined;
    createdById!: number;
    parentReport!: ReportItem;
    userReportSelections!: UserReportSelectionItem[];
    userReportFields!: UserReportFieldItem[];
    userReportAvailabilities!: UserReportAvailabilityItem[];

    constructor(data?: IUserReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.parentReport = new ReportItem();
            this.userReportSelections = [];
            this.userReportFields = [];
            this.userReportAvailabilities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportName = _data["reportName"];
            this.reportDescription = _data["reportDescription"];
            this.createdById = _data["createdById"];
            this.parentReport = _data["parentReport"] ? ReportItem.fromJS(_data["parentReport"]) : new ReportItem();
            if (Array.isArray(_data["userReportSelections"])) {
                this.userReportSelections = [] as any;
                for (let item of _data["userReportSelections"])
                    this.userReportSelections!.push(UserReportSelectionItem.fromJS(item));
            }
            if (Array.isArray(_data["userReportFields"])) {
                this.userReportFields = [] as any;
                for (let item of _data["userReportFields"])
                    this.userReportFields!.push(UserReportFieldItem.fromJS(item));
            }
            if (Array.isArray(_data["userReportAvailabilities"])) {
                this.userReportAvailabilities = [] as any;
                for (let item of _data["userReportAvailabilities"])
                    this.userReportAvailabilities!.push(UserReportAvailabilityItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportName"] = this.reportName;
        data["reportDescription"] = this.reportDescription;
        data["createdById"] = this.createdById;
        data["parentReport"] = this.parentReport ? this.parentReport.toJSON() : <any>undefined;
        if (Array.isArray(this.userReportSelections)) {
            data["userReportSelections"] = [];
            for (let item of this.userReportSelections)
                data["userReportSelections"].push(item.toJSON());
        }
        if (Array.isArray(this.userReportFields)) {
            data["userReportFields"] = [];
            for (let item of this.userReportFields)
                data["userReportFields"].push(item.toJSON());
        }
        if (Array.isArray(this.userReportAvailabilities)) {
            data["userReportAvailabilities"] = [];
            for (let item of this.userReportAvailabilities)
                data["userReportAvailabilities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserReportItem {
    id: number;
    reportName?: string | undefined;
    reportDescription?: string | undefined;
    createdById: number;
    parentReport: ReportItem;
    userReportSelections: UserReportSelectionItem[];
    userReportFields: UserReportFieldItem[];
    userReportAvailabilities: UserReportAvailabilityItem[];
}

export class UserReportSelectionItem implements IUserReportSelectionItem {
    id!: number;
    reportSelectionId!: number;
    selectedValues!: string;

    constructor(data?: IUserReportSelectionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportSelectionId = _data["reportSelectionId"];
            this.selectedValues = _data["selectedValues"];
        }
    }

    static fromJS(data: any): UserReportSelectionItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportSelectionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportSelectionId"] = this.reportSelectionId;
        data["selectedValues"] = this.selectedValues;
        return data;
    }
}

export interface IUserReportSelectionItem {
    id: number;
    reportSelectionId: number;
    selectedValues: string;
}

export class UserReportFieldItem implements IUserReportFieldItem {
    id!: number;
    reportFieldId!: number;
    sortIndex!: number;

    constructor(data?: IUserReportFieldItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportFieldId = _data["reportFieldId"];
            this.sortIndex = _data["sortIndex"];
        }
    }

    static fromJS(data: any): UserReportFieldItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportFieldItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportFieldId"] = this.reportFieldId;
        data["sortIndex"] = this.sortIndex;
        return data;
    }
}

export interface IUserReportFieldItem {
    id: number;
    reportFieldId: number;
    sortIndex: number;
}

export class UserReportAvailabilityItem implements IUserReportAvailabilityItem {
    id!: number;
    ownerAreaId?: number | undefined;
    ownerOrganizationId?: number | undefined;

    constructor(data?: IUserReportAvailabilityItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownerAreaId = _data["ownerAreaId"];
            this.ownerOrganizationId = _data["ownerOrganizationId"];
        }
    }

    static fromJS(data: any): UserReportAvailabilityItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportAvailabilityItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownerAreaId"] = this.ownerAreaId;
        data["ownerOrganizationId"] = this.ownerOrganizationId;
        return data;
    }
}

export interface IUserReportAvailabilityItem {
    id: number;
    ownerAreaId?: number | undefined;
    ownerOrganizationId?: number | undefined;
}

export class UserReportCreateItem implements IUserReportCreateItem {
    name?: string | undefined;
    description?: string | undefined;
    parentReportId!: number;
    userReportSelections?: UserReportSelectionCreateItem[] | undefined;
    userReportFields?: UserReportFieldCreateItem[] | undefined;
    userReportAvailabilities?: UserReportAvailabilityCreateItem[] | undefined;

    constructor(data?: IUserReportCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.parentReportId = _data["parentReportId"];
            if (Array.isArray(_data["userReportSelections"])) {
                this.userReportSelections = [] as any;
                for (let item of _data["userReportSelections"])
                    this.userReportSelections!.push(UserReportSelectionCreateItem.fromJS(item));
            }
            if (Array.isArray(_data["userReportFields"])) {
                this.userReportFields = [] as any;
                for (let item of _data["userReportFields"])
                    this.userReportFields!.push(UserReportFieldCreateItem.fromJS(item));
            }
            if (Array.isArray(_data["userReportAvailabilities"])) {
                this.userReportAvailabilities = [] as any;
                for (let item of _data["userReportAvailabilities"])
                    this.userReportAvailabilities!.push(UserReportAvailabilityCreateItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserReportCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["parentReportId"] = this.parentReportId;
        if (Array.isArray(this.userReportSelections)) {
            data["userReportSelections"] = [];
            for (let item of this.userReportSelections)
                data["userReportSelections"].push(item.toJSON());
        }
        if (Array.isArray(this.userReportFields)) {
            data["userReportFields"] = [];
            for (let item of this.userReportFields)
                data["userReportFields"].push(item.toJSON());
        }
        if (Array.isArray(this.userReportAvailabilities)) {
            data["userReportAvailabilities"] = [];
            for (let item of this.userReportAvailabilities)
                data["userReportAvailabilities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserReportCreateItem {
    name?: string | undefined;
    description?: string | undefined;
    parentReportId: number;
    userReportSelections?: UserReportSelectionCreateItem[] | undefined;
    userReportFields?: UserReportFieldCreateItem[] | undefined;
    userReportAvailabilities?: UserReportAvailabilityCreateItem[] | undefined;
}

export class UserReportSelectionCreateItem implements IUserReportSelectionCreateItem {
    reportSelectionId!: number;
    selectedValues!: string;

    constructor(data?: IUserReportSelectionCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportSelectionId = _data["reportSelectionId"];
            this.selectedValues = _data["selectedValues"];
        }
    }

    static fromJS(data: any): UserReportSelectionCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportSelectionCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportSelectionId"] = this.reportSelectionId;
        data["selectedValues"] = this.selectedValues;
        return data;
    }
}

export interface IUserReportSelectionCreateItem {
    reportSelectionId: number;
    selectedValues: string;
}

export class UserReportFieldCreateItem implements IUserReportFieldCreateItem {
    reportFieldId!: number;
    sortIndex!: number;

    constructor(data?: IUserReportFieldCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportFieldId = _data["reportFieldId"];
            this.sortIndex = _data["sortIndex"];
        }
    }

    static fromJS(data: any): UserReportFieldCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportFieldCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportFieldId"] = this.reportFieldId;
        data["sortIndex"] = this.sortIndex;
        return data;
    }
}

export interface IUserReportFieldCreateItem {
    reportFieldId: number;
    sortIndex: number;
}

export class UserReportAvailabilityCreateItem implements IUserReportAvailabilityCreateItem {
    ownerOrganizationId?: number | undefined;
    ownerAreaId?: number | undefined;

    constructor(data?: IUserReportAvailabilityCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerOrganizationId = _data["ownerOrganizationId"];
            this.ownerAreaId = _data["ownerAreaId"];
        }
    }

    static fromJS(data: any): UserReportAvailabilityCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportAvailabilityCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerOrganizationId"] = this.ownerOrganizationId;
        data["ownerAreaId"] = this.ownerAreaId;
        return data;
    }
}

export interface IUserReportAvailabilityCreateItem {
    ownerOrganizationId?: number | undefined;
    ownerAreaId?: number | undefined;
}

export class UserReportUpdateItem implements IUserReportUpdateItem {
    id!: number;
    reportName?: string | undefined;
    reportDescription?: string | undefined;
    userReportSelections?: UserReportSelectionUpdateItem[] | undefined;
    userReportFields?: UserReportFieldUpdateItem[] | undefined;
    userReportAvailabilities?: UserReportAvailabilityUpdateItem[] | undefined;

    constructor(data?: IUserReportUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportName = _data["reportName"];
            this.reportDescription = _data["reportDescription"];
            if (Array.isArray(_data["userReportSelections"])) {
                this.userReportSelections = [] as any;
                for (let item of _data["userReportSelections"])
                    this.userReportSelections!.push(UserReportSelectionUpdateItem.fromJS(item));
            }
            if (Array.isArray(_data["userReportFields"])) {
                this.userReportFields = [] as any;
                for (let item of _data["userReportFields"])
                    this.userReportFields!.push(UserReportFieldUpdateItem.fromJS(item));
            }
            if (Array.isArray(_data["userReportAvailabilities"])) {
                this.userReportAvailabilities = [] as any;
                for (let item of _data["userReportAvailabilities"])
                    this.userReportAvailabilities!.push(UserReportAvailabilityUpdateItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserReportUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportName"] = this.reportName;
        data["reportDescription"] = this.reportDescription;
        if (Array.isArray(this.userReportSelections)) {
            data["userReportSelections"] = [];
            for (let item of this.userReportSelections)
                data["userReportSelections"].push(item.toJSON());
        }
        if (Array.isArray(this.userReportFields)) {
            data["userReportFields"] = [];
            for (let item of this.userReportFields)
                data["userReportFields"].push(item.toJSON());
        }
        if (Array.isArray(this.userReportAvailabilities)) {
            data["userReportAvailabilities"] = [];
            for (let item of this.userReportAvailabilities)
                data["userReportAvailabilities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserReportUpdateItem {
    id: number;
    reportName?: string | undefined;
    reportDescription?: string | undefined;
    userReportSelections?: UserReportSelectionUpdateItem[] | undefined;
    userReportFields?: UserReportFieldUpdateItem[] | undefined;
    userReportAvailabilities?: UserReportAvailabilityUpdateItem[] | undefined;
}

export class UserReportSelectionUpdateItem implements IUserReportSelectionUpdateItem {
    id?: number | undefined;
    reportSelectionId!: number;
    selectedValues!: string;

    constructor(data?: IUserReportSelectionUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportSelectionId = _data["reportSelectionId"];
            this.selectedValues = _data["selectedValues"];
        }
    }

    static fromJS(data: any): UserReportSelectionUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportSelectionUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportSelectionId"] = this.reportSelectionId;
        data["selectedValues"] = this.selectedValues;
        return data;
    }
}

export interface IUserReportSelectionUpdateItem {
    id?: number | undefined;
    reportSelectionId: number;
    selectedValues: string;
}

export class UserReportFieldUpdateItem implements IUserReportFieldUpdateItem {
    id?: number | undefined;
    reportFieldId!: number;
    sortIndex!: number;

    constructor(data?: IUserReportFieldUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportFieldId = _data["reportFieldId"];
            this.sortIndex = _data["sortIndex"];
        }
    }

    static fromJS(data: any): UserReportFieldUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportFieldUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportFieldId"] = this.reportFieldId;
        data["sortIndex"] = this.sortIndex;
        return data;
    }
}

export interface IUserReportFieldUpdateItem {
    id?: number | undefined;
    reportFieldId: number;
    sortIndex: number;
}

export class UserReportAvailabilityUpdateItem implements IUserReportAvailabilityUpdateItem {
    id?: number | undefined;
    ownerOrganizationId?: number | undefined;
    ownerAreaId?: number | undefined;

    constructor(data?: IUserReportAvailabilityUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownerOrganizationId = _data["ownerOrganizationId"];
            this.ownerAreaId = _data["ownerAreaId"];
        }
    }

    static fromJS(data: any): UserReportAvailabilityUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportAvailabilityUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownerOrganizationId"] = this.ownerOrganizationId;
        data["ownerAreaId"] = this.ownerAreaId;
        return data;
    }
}

export interface IUserReportAvailabilityUpdateItem {
    id?: number | undefined;
    ownerOrganizationId?: number | undefined;
    ownerAreaId?: number | undefined;
}

export class ReportSelectionsListItem implements IReportSelectionsListItem {
    reportId!: number;
    selectionItems!: ReportSelectionListItem[];

    constructor(data?: IReportSelectionsListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectionItems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            if (Array.isArray(_data["selectionItems"])) {
                this.selectionItems = [] as any;
                for (let item of _data["selectionItems"])
                    this.selectionItems!.push(ReportSelectionListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportSelectionsListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSelectionsListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        if (Array.isArray(this.selectionItems)) {
            data["selectionItems"] = [];
            for (let item of this.selectionItems)
                data["selectionItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportSelectionsListItem {
    reportId: number;
    selectionItems: ReportSelectionListItem[];
}

export class ReportSelectionListItem implements IReportSelectionListItem {
    reportSelectionId!: number;
    selectionValues!: ReportSelectionListItemValue[];

    constructor(data?: IReportSelectionListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectionValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportSelectionId = _data["reportSelectionId"];
            if (Array.isArray(_data["selectionValues"])) {
                this.selectionValues = [] as any;
                for (let item of _data["selectionValues"])
                    this.selectionValues!.push(ReportSelectionListItemValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportSelectionListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSelectionListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportSelectionId"] = this.reportSelectionId;
        if (Array.isArray(this.selectionValues)) {
            data["selectionValues"] = [];
            for (let item of this.selectionValues)
                data["selectionValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportSelectionListItem {
    reportSelectionId: number;
    selectionValues: ReportSelectionListItemValue[];
}

export class ReportSelectionListItemValue implements IReportSelectionListItemValue {
    id!: number;
    value!: string;

    constructor(data?: IReportSelectionListItemValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ReportSelectionListItemValue {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSelectionListItemValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

export interface IReportSelectionListItemValue {
    id: number;
    value: string;
}

export class ReportDataItem implements IReportDataItem {
    reportId!: number;
    separator!: string;
    reportDataRows!: string[];
    reportAlphaChannelRows!: string[];

    constructor(data?: IReportDataItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reportDataRows = [];
            this.reportAlphaChannelRows = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.separator = _data["separator"];
            if (Array.isArray(_data["reportDataRows"])) {
                this.reportDataRows = [] as any;
                for (let item of _data["reportDataRows"])
                    this.reportDataRows!.push(item);
            }
            if (Array.isArray(_data["reportAlphaChannelRows"])) {
                this.reportAlphaChannelRows = [] as any;
                for (let item of _data["reportAlphaChannelRows"])
                    this.reportAlphaChannelRows!.push(item);
            }
        }
    }

    static fromJS(data: any): ReportDataItem {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDataItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["separator"] = this.separator;
        if (Array.isArray(this.reportDataRows)) {
            data["reportDataRows"] = [];
            for (let item of this.reportDataRows)
                data["reportDataRows"].push(item);
        }
        if (Array.isArray(this.reportAlphaChannelRows)) {
            data["reportAlphaChannelRows"] = [];
            for (let item of this.reportAlphaChannelRows)
                data["reportAlphaChannelRows"].push(item);
        }
        return data;
    }
}

export interface IReportDataItem {
    reportId: number;
    separator: string;
    reportDataRows: string[];
    reportAlphaChannelRows: string[];
}

export class ReportFilterSelection implements IReportFilterSelection {
    reportSelectionId!: number;
    selectedValues!: string;

    constructor(data?: IReportFilterSelection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportSelectionId = _data["reportSelectionId"];
            this.selectedValues = _data["selectedValues"];
        }
    }

    static fromJS(data: any): ReportFilterSelection {
        data = typeof data === 'object' ? data : {};
        let result = new ReportFilterSelection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportSelectionId"] = this.reportSelectionId;
        data["selectedValues"] = this.selectedValues;
        return data;
    }
}

export interface IReportFilterSelection {
    reportSelectionId: number;
    selectedValues: string;
}

export abstract class ServiceError implements IServiceError {

    constructor(data?: IServiceError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ServiceError {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServiceError' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IServiceError {
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}